"use strict";
/**
* IBM Confidential
* OCO Source Materials
* IBM Business Platform: Dashboard
* (C) Copyright IBM Corp. 2020
* The source code for this program is not published or otherwise divested of its trade secrets,
* irrespective of what has been deposited with the U.S. Copyright Office
**/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIONS;

(function (ACTIONS) {
  ACTIONS["SET_SCALE"] = "setScale";
  ACTIONS["SET_PALETTE_ID"] = "setPaletteId";
  ACTIONS["SET_BACKGROUND_OPACITY"] = "setBackgroundOpacity";
  ACTIONS["ADD_RULE"] = "addRule";
  ACTIONS["DELETE_RULE"] = "deleteRule";
  ACTIONS["MOVE_RULE"] = "moveRule";
  ACTIONS["SET_RANGE_OPERATOR"] = "setRangeOperator";
  ACTIONS["SET_START_CONDITION_TYPE"] = "setStartConditionType";
  ACTIONS["SET_START_CONDITION_VALUE"] = "setStartConditionValue";
  ACTIONS["SET_END_CONDITION_TYPE"] = "setEndConditionType";
  ACTIONS["SET_END_CONDITION_VALUE"] = "setEndConditionValue";
  ACTIONS["SET_RULE_STYLE_TEXT_COLOR"] = "setRuleStyleTextColor";
  ACTIONS["SET_RULE_STYLE_FILL_COLOR"] = "setRuleStyleFillColor";
  ACTIONS["SET_RULE_STYLE_SHAPE"] = "setRuleStyleShape";
  ACTIONS["SET_SUMMARY_FILL_COLOR"] = "setSummaryFillColor";
  ACTIONS["SET_COLOR_BY"] = "setColorBy";
  ACTIONS["SET_HAS_MIN_MAX"] = "setHasMinMax";
})(ACTIONS = exports.ACTIONS || (exports.ACTIONS = {}));
